import React from 'react';
import p from 'translation';
import { App } from 'core/types/app';

import { ReactComponent as CalendarIcon } from './icon/calendar-submenu.svg';
import { ReactComponent as ConfigIcon } from './icon/config.svg';
import { ReactComponent as ExerciseIcon } from './icon/dumbbell.svg';

import icon from './icon.svg';
import theme from 'theme';

const calendar: App = {
  id: 'calendar',
  name: p.t('apps.calendar.calendar'),
  icon,
  color: theme.palette.calendar,
  app: React.lazy(() => import(/* webpackChunkName: "calendar" */ './app')),
  navigation: [
    {
      title: p.t('apps.calendar.pages.calendar'),
      path: '/',
      hasAccess: () => true,
      icon: <CalendarIcon />,
      forceActive: () =>
        ['/app/calendar/edit', '/app/calendar/create'].find(str =>
          window.location.pathname.includes(str),
        ) !== undefined,
    },
    {
      title: p.t('apps.calendar.pages.exercise'),
      path: '/exercise',
      hasAccess: (_, organizationId) => {
        // TODO: remove when we're out of exorlive MVP
        return (
          !!organizationId &&
          window.__ENV__.CONTENT_PACK_ORG.split(',').includes(organizationId)
        );
      },
      icon: <ExerciseIcon />,
      forceActive: () =>
        window.location.pathname.includes('/app/calendar/exercise'),
    },
    {
      title: p.t('apps.calendar.pages.configuration'),
      path: '/settings',
      hasAccess: () => true,
      icon: <ConfigIcon />,
      forceActive: () =>
        window.location.pathname.includes('/app/calendar/settings/'),
    },
  ],
};

export default calendar;
